export default function ({state, getters}) {
    state.form.AgreementCodes.forEach(id => {
        let item = getters['agreements/agreement'](id);
        if (!item) return;
        item.requests.forEach(i => {
            switch (state.form.PaymentDirection) {
                case 0:
                    i.sum = i.inp > 0 ? i.inp : 0;
                    break;
                case 1:
                    i.sum = i.out > 0 ? i.out : 0;
                    break;
            }
        });
        if (state.system.action==='add' || state.system.action==='order') {
            state.form.Sum = getters['agreements/sum_all'];
        }
    })
}
